
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import constants from './constants';
import Icon from './Icon';
import idgen from './idgen';

import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';


const styles = theme => ({
  appBar: {
    position: 'relative',
    background: '#0288d1',
  },
  flex: {
    flex: 1,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',

  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  root: {
    padding: '2rem',
    boxSizing: 'border-box'
  },

  input: {
    margin: theme.spacing.unit,
    maxWidth: '100%'
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class Autocomplete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || '',
      dep: [],
      filter: true,
      name: '',
      region: '',
      inCheck: true
    };

    this.renderIcon = this.renderIcon.bind(this);
    this.renderDropdown = this.renderDropdown.bind(this);
    this._onChange = this._onChange.bind(this);
  }

  componentWillReceiveProps({ value }) {
    if (value !== undefined) {
      this.setState({ value });
    }
  }

  componentWillUnmount() {
    this.setState = ({
      value: '',
      dep: [],
      filter: true,
      name: '',
      region: ''
    });
  }
  autoClean = () => {
    this.setState({
      value: '',
      inCheck: true,
      region: '',
      name: '',
    })

    this.props.onChange('')
  }
  autoApi(val) {
    setTimeout(() => {
      this.props.action(val);
    }, 200);

  }
  renderCleanButton = () => {
    if (this.state.inCheck) {
      return null
    }
    return (
      <InputAdornment position="end">
        <IconButton
          aria-label="Toggle password visibility"
          onClick={this.autoClean}
        >
          <DeleteIcon />
        </IconButton>
      </InputAdornment>
    )
  }

  renderIcon(icon, iconClassName) {
    return <Icon className={iconClassName}>{icon}</Icon>;
  }

  renderDropdown(data, minLength, limit) {
    const { value } = this.state;
    // if (minLength) {
    //   return null
    // }
    if (minLength > value.length || !value) {
      return null;
    }

    let matches = data.map((item) => {
      return item
    });
    if (limit) matches = matches.slice(0, limit);

    if (matches.length === 0) {
      return null;
    }
    if (!this.state.filter) {
      return null;
    }

    return (
      <ul className='autocomplete-content dropdown-content'>
        {data.map((key, idx) => {
          const index = key.code.toUpperCase().indexOf(value.toUpperCase());
          return (
            <li key={key + '_' + idx} onClick={this._onAutocomplete.bind(this, key.code, key.region, key.name, key.id)}>
              <span>
                {index !== 0 ? key.code.substring(0, index) : ''}
                <span className='highlight'>{value}</span>
                {key.code.length !== index + value.length ? key.code.substring(index + value.length) : ''}
                <span className='right'> {key.region} </span>
              </span>
            </li>
          );
        })}
      </ul>
    );
  }

  _onChange(evt) {
    // const { onChange } = this.props;
    const value = evt.target.value;
    // console.log(this.props)
    // if (onChange) { onChange(value); }
    if (value.length > 3) {
      this.setState({ filter: true })
      this.autoApi(value);
    } else {
      this.setState({ region: '', name: '', inCheck: true })
      this.props.onChange('')
    }
    this.setState({ value });
  }

  _onAutocomplete(value, region, name, id, evt) {
    const { onChange, onAutocomplete } = this.props;
    if (onAutocomplete) { onAutocomplete(value); }
    if (onChange) { onChange(evt, value); }
    this.setState({
      filter: false,
      region: region, name: name, inCheck: false
    })
    this.setState({ value });
    this.props.onChange(id);
  }

  render() {
    const {
      id,
      title,
      s,
      m,
      l,
      placeholder, minLength, limit

    } = this.props;

    const _id = id || `autocomplete-${idgen()}`;
    const sizes = { s, m, l };
    let classes = {
      col: true
    };
    constants.SIZES.forEach(size => {
      classes[size + sizes[size]] = sizes[size];
    });
    // const minLength = 3;
    // const limit = 10
    return (
      <React.Fragment>
        <Grid item xs={12} sm={4} >
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel htmlFor={_id}>{title}</InputLabel>
            <Input
              disabled={(this.state.inCheck) ? false : true}
              placeholder={placeholder}
              className={classes.input}
              id={_id}
              onChange={this._onChange}
              type='text'
              value={this.state.value}
              maxLength="5"
              // onFocus={this.autoClean}
              endAdornment={this.renderCleanButton()}
            />

            {this.renderDropdown(this.props.departament, minLength, limit)}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel className={classes.input} htmlFor="disabled">Департамент</InputLabel>
            <Input type="text" id="disabled" value={this.state.name} disabled />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel className={classes.input} htmlFor="disabled">Регіон</InputLabel>
            <Input type="text" id="disabled" value={this.state.region} disabled />
          </FormControl>
        </Grid>
      </React.Fragment>
    );
  }
}

Autocomplete.propTypes = {
  /**
   * Uniquely identifies <input> generated by this component
   * Used by corresponding <label> for attribute
   */
  id: PropTypes.string,
  className: PropTypes.string,
  /*
   * The title of the autocomplete component.
   */
  title: PropTypes.string,
  /*
   * An object with the keys of the items to match in autocomplete
   * The values are either null or a location to an image
   */
  // data: PropTypes.object.isRequired,
  /*
   * Optional materialize icon to add to the autocomplete bar
   */
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  s: PropTypes.number,
  m: PropTypes.number,
  l: PropTypes.number,
  offset: PropTypes.string,
  /*
   * Determine input length before dropdown
   */
  minLength: PropTypes.number,
  /**
   * The max amount of results that can be shown at once. Default: Infinity
   * */
  limit: PropTypes.number,
  /**
   * Placeholder for input element
   * */
  placeholder: PropTypes.string,
  /**
   * Called when the value of the input gets changed - by user typing or clicking on an auto-complete item.
   * Function signature: (event, value) => ()
   */
  onChange: PropTypes.func,
  /**
   * Called when auto-completed item is selected.
   * Function signature: (value) => ()
   */
  onAutocomplete: PropTypes.func,
  /**
   * The value of the input
   */
  value: PropTypes.string
};

export default withStyles(styles)(Autocomplete);



// WEBPACK FOOTER //
// ./src/src/Autocomplete.js